import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../../components/Button';
import { StyledDropdownContainer, StyledDropdownOption } from '../../../../components/Dropdown/styles';
import { Tooltip } from '../../../../components/Tooltip';

export const StyledCompetitorsDropdownWrapper = styled.div`
  display: flex;
  margin: 0 16px;
`;

export const StyledCompetitorsDropdown = styled.div`
  position: relative;

  ${StyledDropdownContainer} {
    top: -8px;
  }
`;

export const StyledCompetitorsDropdownButton = styled.button`
  width: 257px;
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
  padding: 8px 16px;
  border-radius: 3px;
  border: 1px solid ${colorsPalettes.carbon[50]};
  background-color: ${colorsPalettes.carbon[0]};
  cursor: pointer;
  position: relative;
  ${setFontVariant('input2', colorsPalettes.carbon[200])};

  ${SWReactIcons} svg path {
    fill: ${colorsPalettes.carbon[200]};
  }

  :disabled {
    cursor: not-allowed;
    background-color: ${colorsPalettes.bluegrey[200]};
    border-color: ${colorsPalettes.midnight[50]};
  }
`;

export const DropdownButtonTooltip = styled(Tooltip)`
  margin-right: 14px;
`;

export const StyledCompetitorsCount = styled.span`
  ${setFontVariant('subtitle1', colorsPalettes.carbon[200])};
  align-self: center;
`;

export const StyledCompetitorsList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0 8px 0;
  height: 317px;
`;

export const StyledOpenWebsiteButton = styled(Button)`
  padding: 8px;
  width: 32px;
  height: 32px;
  background-color: ${colorsPalettes.carbon[25]};
  opacity: 0;
  transition:
    opacity 0.2s ease-in-out,
    background-color 0.2s ease-in-out;

  svg path {
    fill: ${colorsPalettes.carbon[300]};
  }
`;

export const StyledRemoveCompetitorButton = styled(StyledOpenWebsiteButton)`
  margin-left: auto;
`;

export const StyledCompetitorItem = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 12px 16px;
  background-color: ${colorsPalettes.carbon[0]};
  border-bottom: 1px solid ${colorsPalettes.carbon[100]};
  column-gap: 8px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${colorsPalettes.carbon[25]};

    ${StyledOpenWebsiteButton} {
      opacity: 1;
    }
  }
`;

export const StyledCompetitorFavicon = styled.img`
  width: 24px;
  height: 24px;
  padding: 4px;
  border-radius: 6px;
  border: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledCompetitorDomain = styled.span`
  ${setFontVariant('input2', colorsPalettes.carbon[400])}
`;

export const StyledCompetitorOption = styled(StyledDropdownOption)`
  column-gap: 8px;
  padding: 10px 16px;
`;
